// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCkv4plFsK0iziW5lkXEN2FAuUOHRbOdPQ",
  authDomain: "kadecsrowy.firebaseapp.com",
  projectId: "kadecsrowy",
  storageBucket: "kadecsrowy.appspot.com",
  messagingSenderId: "173919586870",
  appId: "1:173919586870:web:fe57b807cd39c2adaa6697",
  measurementId: "G-XFPRQ1YCR4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const db = getFirestore();
export default app;
// const analytics = getAnalytics(app);
